export interface FormValues {
	password: string;
	repeatPassword: string;
	email: string;
	firstName: string;
	lastName: string;
	phone: string;
	country: string;
	crop: string;
	companyName: string;
	linkedinProfile: string;
	representativeName: string;
	representativeLastName: string;
	companyId: string;
	termsAndConditions: boolean;
}

export const registrationInitialValues = {
	email: '',
	password: '',
	repeatPassword: '',
	firstName: '',
	lastName: '',
	representativeName: '',
	representativeLastName: '',
	phone: '',
	crop: '',
	country: '',
	companyName: '',
	companyId: '',
	linkedinProfile: '',
	termsAndConditions: false,
};

export interface LoginValues {
	email: string;
	password: string;
}

export const loginValues = {
	email: '',
	password: '',
};

export interface EmailValues {
	email: string;
}

export const emailValues = {
	email: '',
};

export interface ResetValues {
	password: string;
	repeatPassword: string;
}

export const resetValues = {
	password: '',
	repeatPassword: '',
};
